<div class="content-container">
  <nav class="navbar sticky-top">
    <div class="d-grid gap-2 d-flex navbar-brand">
      <button (click)="this.location.back();" type="button" ngbTooltip="Back" placement="bottom" class="btn btn-primary backBtn" aria-label="Back">
        <fa-icon [icon]="faAngleLeft"></fa-icon>
      </button>
      <h2 class="mobileHeading">Edit Multi-Year-Agreement</h2>
    </div>
    <div>
      <span [ngbTooltip]="multiYearAgreementProjects()?.length > 0 ? 'You can only delete an MYA if there are no assigned projects.' : null" placement="bottom" triggers="hover">
        <button type="button" class="btn btn-danger" (click)="openDeleteMyaConfirmationModal();" [disabled]="multiYearAgreementProjects()?.length > 0">
          <fa-icon class="button-icon-left" [icon]="faTrashCan"></fa-icon>
          <span>Delete</span>
        </button>
      </span>
      <button type="button" class="btn btn-primary ms-2" (click)="updateMultiYearAgreement();">
        <fa-icon class="button-icon-left" [icon]="faSave"></fa-icon>
        <span>Save</span>
      </button>
    </div>
  </nav>
  <div class="content-wrap">
    <form [formGroup]="myaForm">
      <div class="row">
        <div class="col-lg-4 mt-3">
          <div class="card">
            <div class="card-header d-flex justify-content-between align-items-center">
              <h5>General</h5>
              <button type="button" class="btn" [ngClass]="isInputLocked() ? 'btn-primary' : 'btn-secondary'" (click)="toggleLockUnlock();">
                <fa-icon class="button-icon-left" [icon]="isInputLocked() ? faUnlock : faLock"></fa-icon>
                <span>{{ isInputLocked() ? 'Unlock' : 'Lock' }}</span>
              </button>
            </div>
            <div class="card-body" style="min-height: 328px;">
              <div class="mb-3">
                <label for="MYA_CLIENT_NAME">Client</label>
                <div class="input-group">
                  <input id="MYA_CLIENT_NAME" type="text" class="form-control" formControlName="clientName" readonly>
                  <button type="button" class="btn btn-outline-primary" [routerLink]="['/clients', multiYearAgreement()?.clientId]">
                    <fa-icon [icon]="faExternalLinkAlt"></fa-icon>
                  </button>
                </div>
              </div>

              <div class="mb-3">
                <label for="MYA_SITE">Site</label>
                <div class="input-group">
                  <input id="MYA_SITE" type="text" class="form-control" formControlName="site" readonly>
                  <button type="button" class="btn btn-outline-primary" [routerLink]="['/sites', multiYearAgreement()?.siteId]">
                    <fa-icon [icon]="faExternalLinkAlt"></fa-icon>
                  </button>
                </div>
              </div>

              <div class="mb-3">
                <label for="MYA_START_YEAR">Start Year</label>
                <input id="MYA_START_YEAR" type="number" class="form-control" formControlName="startYear" placeholder="2025" required [class.is-invalid]="startYear?.invalid && (startYear?.dirty || startYear?.touched)" [readOnly]="isInputLocked() ? true : false">
                <div *ngIf="startYear?.invalid && (startYear?.dirty || startYear?.touched)">
                  <div *ngIf="startYear?.errors?.required" class="input-validation-msg">Start Year is required.</div>
                </div>
              </div>

              <div class="mb-3">
                <label for="MYA_AGREEMENT_LENGTH">Agreement Length (Years)</label>
                <input id="MYA_AGREEMENT_LENGTH" type="number" class="form-control" formControlName="agreementLength" placeholder="Years" required [class.is-invalid]="agreementLength?.invalid && (agreementLength?.dirty || agreementLength?.touched)" [readOnly]="isInputLocked() ? true : false">
                <div *ngIf="agreementLength?.invalid && (agreementLength?.dirty || agreementLength?.touched)">
                  <div *ngIf="agreementLength?.errors?.required" class="input-validation-msg">Agreement Length is required.</div>
                </div>
              </div>

              <div class="mb-3">
                <label for="MYA_START_YEAR">Final Year</label>
                <input id="MYA_START_YEAR" type="number" class="form-control" formControlName="finalYear" placeholder="2025" readonly>
              </div>

              <div>
                <label for="MYA_STATUS">Status</label>
                <select id="MYA_STATUS" class="form-select" formControlName="status" required [class.is-invalid]="status?.invalid && (status?.dirty || status?.touched)">
                  <option value="ACTIVE">Active</option>
                  <option value="COMPLETED">Completed</option>
                  <option value="CANCELED">Canceled</option>
                </select>
                <div *ngIf="status?.invalid && (status?.dirty || status?.touched)">
                  <div *ngIf="status?.errors?.required" class="input-validation-msg">Status is required.</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-4 mt-3">
        </div>
        <div class="col-lg-4 mt-3">
        </div>
      </div>
    </form>

    <ul ngbNav #nav="ngbNav" class="nav-tabs mt-3">
      <!-- Assigned Projects Tab -->
      <li ngbNavItem="ASSIGNED_PROJECTS">
        <a ngbNavLink (click)="getMultiYearAgreementById();">Assigned Projects</a>
        <ng-template ngbNavContent>
          <!-- Assigned Projects Table -->
          <div class="card mt-3">
            <div class="card-header">
              <h5>Assigned Projects</h5>
              <div class="ms-auto">
                <button type="button" class="btn btn-secondary" [disabled]="disabledGenerateNextMyaProjectButton" (click)="openAssignProjectToMyaModal();">
                  <span>Assign Project</span>
                </button>
              </div>
              <div class="ms-2" *ngIf="multiYearAgreementProjects()?.length != 0">
                <button class="btn btn-primary" [disabled]="disabledGenerateNextMyaProjectButton" (click)="openGenerateNextMyaProjectModal();">
                  <span>Generate Next MYA Project</span>
                </button>
              </div>
            </div>
            <div class="card-body">
              <div class="table-responsive">
                <table *ngIf="!isMobile" class="table table-hover">
                  <thead>
                    <tr>
                      <th>MYA Project Year</th>
                      <th>Project Year</th>
                      <th>Project Name</th>
                      <th>Accepted Proposal Total</th>
                      <th>Project Stage</th>
                      <th>Project Status</th>
                      <th>Updated</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let myaProject of multiYearAgreementProjects(); let i = index;" routerLink="/projects/{{ myaProject?.projectId }}">
                      <td data-label="MYA Project Year">Year {{ myaProject?.myaProjectYear }} of {{  multiYearAgreement()?.length }}</td>
                      <td data-label="Project Year">{{ myaProject?.projectYear }}</td>
                      <td data-label="Project Name">{{ myaProject?.projectName }}</td>
                      <td data-label="Accepted Proposal Total">{{ myaProject?.acceptedProposalTotal | currency: 'USD' || 'N/A' }}</td>
                      <td data-label="Stage">{{ myaProject?.stage | projectStage }}</td>
                      <td data-label="Status">{{ myaProject?.status | projectStatus }}</td>
                      <td data-label="Updated">{{ myaProject?.updatedAt | date : 'MM/dd/yyyy' }}</td>
                    </tr>
                    <tr *ngIf="multiYearAgreementProjects()?.length == 0">
                      <td colspan="7" class="text-center">No Assigned Projects</td>
                    </tr>
                  </tbody>
                </table>

                <div *ngIf="isMobile" class="scrollable">
                  <ul class="list-group">
                    <li *ngFor="let myaProject of multiYearAgreementProjects(); let i = index;" class="list-group-item list-group-item-action" routerLink="/projects/{{ myaProject?.projectId }}">
                      <div class="d-flex list-group-container">
                        <div>
                          <strong>{{ myaProject?.projectName }}</strong>
                          <div>MYA Project Year: {{ myaProject?.myaProjectYear }}</div>
                          <div>Project Year: {{ myaProject?.projectYear }}</div>
                          <div>Accepted Proposal Total: {{ myaProject?.acceptedProposalTotal | currency: 'USD' || 'N/A' }}</div>
                          <div>Stage: {{ myaProject?.stage | projectStage }}</div>
                          <div>Status: {{ myaProject?.status | projectStatus }}</div>
                          <div>Updated: {{ myaProject?.updatedAt | date : 'MM/dd/yyyy' }}</div>
                        </div>
                      </div>
                    </li>
                    <li *ngIf="multiYearAgreementProjects()?.length == 0" class="list-group-item">No Assigned Projects</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </ng-template>
      </li>
    </ul>
    <div id="NAV_OUTPUT" [ngbNavOutlet]="nav" class="mt-2"></div>
  </div>
</div>

<ngx-spinner type="ball-scale-multiple">
  <p class="loading-spinner">Loading...</p>
</ngx-spinner>